<template>
  <div id="app" :class="active === 'home' ? 'appDarkColor' : 'appLightColor'">
    <vs-navbar
      target-scroll="#content-wrapper"
      padding-scroll
      center-collapsed
      shadowScroll
      v-model="active"
      :class="active === 'home' ? 'navDarkColor' : 'navLightColor'"
    >
      <template #left v-if="mobile">
        <vs-button @click="activeSidebar = !activeSidebar" transparent icon>
          <i
            class="bx bx-menu-alt-left"
            :class="active === 'home' ? 'menuButtonDark' : 'menuButtonLight'"
          />
        </vs-button>
      </template>
      <template v-if="!mobile" #right>
        <vs-navbar-item
          :active="active == 'home'"
          id="home"
          to="/"
          class="navItems"
        >
          {{ $t("app.menu.home") }}
        </vs-navbar-item>
        <vs-navbar-item
          :active="active == 'services'"
          id="services"
          to="/services"
          class="navItems"
        >
          {{ $t("app.menu.services") }}
        </vs-navbar-item>
        <vs-navbar-item
          :active="active == 'portfolio'"
          id="portfolio"
          to="/portfolio"
          class="navItems"
        >
          {{ $t("app.menu.portfolio") }}
        </vs-navbar-item>
        <vs-navbar-item
          :active="active == 'about'"
          id="about"
          to="/about"
          class="navItems"
        >
          {{ $t("app.menu.about") }}
        </vs-navbar-item>
        <vs-navbar-item
          :active="active == 'contact'"
          id="contact"
          to="/contact"
          class="navItems"
        >
          {{ $t("app.menu.contact") }}
        </vs-navbar-item>
      </template>
    </vs-navbar>
    <vs-sidebar absolute v-model="active" :open.sync="activeSidebar">
      <template #logo>
        <img src="./assets/LogoAlt.svg" alt="LogoAlt" width="100%">
      </template>
      <vs-sidebar-item
        :active="active == 'home'"
        id="home"
        to="/">
        <template #icon>
          <i class="bx bx-home"></i>
        </template>
        {{ $t("app.menu.home") }}
      </vs-sidebar-item>
      <vs-sidebar-item
        :active="active == 'services'"
        id="services"
        to="/services">
        <template #icon>
          <i class="bx bxs-shopping-bags"></i>
        </template>
        {{ $t("app.menu.services") }}
      </vs-sidebar-item>
      <vs-sidebar-item
        :active="active == 'portfolio'"
        id="portfolio"
        to="/portfolio"
      >
        <template #icon>
          <i class='bx bxs-briefcase-alt-2' />
        </template>
        {{ $t("app.menu.portfolio") }}
      </vs-sidebar-item>
      <vs-sidebar-item
        :active="active == 'about'"
        id="about"
        to="/about"
      >
        <template #icon>
          <i class="bx bxs-receipt"></i>
        </template>
        {{ $t("app.menu.about") }}
      </vs-sidebar-item>
      <vs-sidebar-item
        :active="active == 'contact'"
        id="contact"
        to="/contact"
        class="navItems"
      >
        <template #icon>
          <i class="bx bx-chat"></i>
        </template>
        {{ $t("app.menu.contact") }}
      </vs-sidebar-item>
    </vs-sidebar>
    <div id="content-wrapper">
      <div id="padding-scroll-content" @click="activeSidebar = false" :style="mobile ? 'padding: 4.5rem 2rem; height: 80vh' : ''">
        <router-view :setActive="setActive" :contactForm="contactForm" :setContactForm="setContactForm" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    active: '',
    mobile: false,
    activeSidebar: false,
    contactForm: {},
  }),
  beforeMount() {
    const mediaQuery = window.matchMedia('(max-width: 590px)');
    if (mediaQuery.matches) {
      // when screen width is less than 590px
      this.mobile = true;
    }
    this.active = this.$router.currentRoute.name.toLowerCase();
  },
  methods: {
    setActive(to) {
      this.active = to;
    },
    setContactForm(form) {
      console.log(form);
      this.contactForm = form;
    },
  },
};
</script>

<style>
body {
  margin: 0;
  height: 100vh;
  overflow: hidden;
}

#app {
  font-family: Poppins, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
}

#content-wrapper {
  height: 100%;
  display: flex;
  align-items: center;
  margin: auto 0;
  overflow-y: auto;
  width: 100%;
}

#padding-scroll-content {
  /* height: calc(100vh - 20vh); */
  margin-top: 5rem;
  padding: 6rem;
  width: 100%;
}

.navItems {
  padding: 0 2rem;
}

.navDarkColor {
  background-color: #000000;
  color: #ffffff;
}

.navLightColor {
  background-color: #ffffff;
  color: #000000;
}

.appDarkColor {
  background-color: #000000;
  color: #ffffff;
}

.appLightColor {
  background-color: #ffffff;
  color: #000000;
}

.vs-input {
  width: 90%;
}

.menuButtonDark {
  color: #ffffff;
}

.menuButtonLight {
  color: #000000;
}

.vs-dialog--scroll .vs-dialog__content {
    max-height: calc(98vh - 200px);
    overflow: auto;
}
</style>
